// @ts-nocheck
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { Checkbox } from "@/components/ui/checkbox"
import { useState } from "react";
import _ from 'lodash';

function MultiSelect({ label = 'Select', options, defaultValue = [], value = [], onChange }) {

  const [selected, setSelected] = useState(defaultValue);

  const placeholder = selected.length > 0 ? _.map(selected, (option) => _.capitalize(option)).join(', ') : label;
  return (
    <Select
      onValueChange={(value) => {
        if (selected.includes(value)) {
          const newSelected = selected.filter(v => v !== value);
          setSelected(newSelected);
          onChange(newSelected);
        } else {
          const newSelected = [...selected, value];
          setSelected(newSelected);
          onChange(newSelected);
        }
      }}
    >
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option} value={option}>
              <div className="flex items-center gap-2">
                <Checkbox
                  checked={selected.includes(option)}
                  className="pointer-events-none"
                  onCheckedChange={() => {
                    debugger;
                    setSelected(selected.includes(option) ? selected.filter(v => v !== option) : [...selected, option]);
                  }}
                />
                {_.capitalize(option)}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </SelectTrigger>
    </Select>
  );
}

export default MultiSelect;